export default __webpack_public_path__ + "static/media/ap.57874b3d.png";